import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';

import PageLayoutStore from '@src/business-components/page-layout/store';
import { observable } from 'mobx';
import routeConfigs from '@src/pages/app-router/route-configs';
import Toast from '@src/components/toast';
import { useRequest } from 'ahooks';
import ArticleBtnStore from '@src/business-components/article-btn/store';
import { useEffect } from 'react';
import { getOmniData, getOmniDetail, StrategyChannelId } from '@src/services/omni-api';
import { HIDE_DATA } from '@src/constants/urls';
import { createContentRouteUrl, getContentRouteQuery } from '@src/utils/content-route-util';
class StrategyDetailStore extends BaseStore {
  @observable hideData = HIDE_DATA;

  pageSize = 10;
  articleBtnStore = new ArticleBtnStore();
  pageLayoutStore = new PageLayoutStore({
    type: '攻略资料',
    isHideStrategy: () => this.hideData
  });
  //目录id
  @observable categoryId;

  //文章id
  @observable contentId;

  //文章内容
  @observable currentArticle;

  //页码
  @observable page;

  @observable list;

  /**
   * 获取文章id
   */
  getContentId = () => {
    const { contentId, categoryId, page } = getContentRouteQuery(this.$routeMatch.query);
    this.page = Number(page) || 1;
    this.categoryId = categoryId;
    this.contentId = contentId;
    if (this.contentId) {
      this.pageLayoutStore.breadcrumbNavStore.navItems = [
        {
          label: '官网首页',
          path: routeConfigs.MAIN.getFormatPath({ part: 'data' })
        },
        { label: '攻略资料', href: createContentRouteUrl('/strategy-list', { categoryId: this.categoryId }) },
        { label: '正文', href: createContentRouteUrl('/strategy-detail', { categoryId: this.categoryId, contentId: this.contentId, page: this.page }) }
      ];
    }
  };

  setArticleBtn = async detailList => {
    // console.log('set list:', detailList);
    const contentId = this.contentId;
    // 设置 上一页、下一页数据
    const index = detailList.findIndex(item => item.contentId === contentId);
    let newPage = this.page;
    if (index === 0) {
      // index为0,判断前面是否还有页数
      if (this.page === 1) {
        this.articleBtnStore.prevData = {};
      } else {
        newPage = newPage - 1;
        const prevRes = await getOmniData(StrategyChannelId, [
          {
            dataSourceId: this.categoryId,
            page: this.page - 1,
            perPage: this.pageSize
          }
        ]);
        this.articleBtnStore.prevData = prevRes?.[this.categoryId]?.result?.items?.[prevRes?.[this.categoryId]?.result?.items?.length - 1] || {};
      }
      this.articleBtnStore.nextData = detailList[index + 1] || {};
    } else if (index === detailList.length - 1) {
      newPage = newPage + 1;
      // index=最后一项,判断后面是否还有数据
      const nextRes = await getOmniData(StrategyChannelId, [
        {
          dataSourceId: this.categoryId,
          page: this.page + 1,
          perPage: this.pageSize
        }
      ]);
      this.articleBtnStore.prevData = detailList[index - 1] || {};
      this.articleBtnStore.nextData = nextRes?.[this.categoryId]?.result?.items?.[0] || {};
    } else {
      this.articleBtnStore.prevData = detailList[index - 1] || {};
      this.articleBtnStore.nextData = detailList[index + 1] || {};
    }
    // console.log(newPage);
    this.articleBtnStore.gotoDetail = item => {
      if (item.jump_link === 'link') {
        window.open(item.art_link.url);
      } else {
        window.location.href = createContentRouteUrl('/strategy-detail', { categoryId: this.categoryId, contentId: item.contentId, page: newPage });
      }
    };
  };

  getStrategyDetailAsync = () => {
    return getOmniDetail(this.contentId)
      .then(res => {
        // console.log(res);
        this.currentArticle = res;
      })
      .catch(error => {
        Toast.fail(error.msg);
      });
  };

  getStrategyListAsync = async () => {
    return getOmniData(StrategyChannelId, [
      {
        dataSourceId: this.categoryId || '',
        page: parseInt(this.page, 10),
        perPage: this.pageSize
      }
    ])
      .then(res => {
        this.list = res[this.categoryId].result.items;
        this.setArticleBtn(res[this.categoryId].result.items);
      })
      .catch(error => {
        Toast.fail(error.msg);
      });
  };
  use() {
    super.use();
    this.getStrategyDetailRequest = useRequest(
      async () => {
        await this.getStrategyDetailAsync();
      },
      { manual: true }
    );
    this.getStrategyListRequest = useRequest(
      async () => {
        await this.getStrategyListAsync();
      },
      { manual: true }
    );
    useMount(() => {
      this.getContentId();
      this.pageLayoutStore.breadcrumbNavStore.redirect = url => {
        this.redirect(url);
      };
    });

    useEffect(
      () => {
        if (this.contentId) {
          this.getStrategyDetailRequest.run();
          this.getStrategyListRequest.run();
        }
      },
      [this.contentId]
    );
  }
}

export default StrategyDetailStore;
